export default "__VITE_ASSET__3b1987b8__"